'use strict';

var React = require('react');
var index = require('./index-01e339e9.js');
require('tslib');
var Divider$1 = require('./Divider-b2896e81.js');
var DatePicker = require('./DatePicker-a803edfa.js');
require('events');
require('react/jsx-runtime');
require('@emotion/react');
require('react-dom');
require('react-intl');
require('react-hook-form');
require('./ListItem-6fbaa1b9.js');

/** https://mui.com/api/divider/ */
const Divider = (props) => {
    return (React.createElement(index.MultiThemeProvider, null,
        React.createElement(Divider$1.Divider, Object.assign({}, props))));
};

const CalStartIcon = (props) => (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": 'calStartIcon' }),
    React.createElement("path", { d: 'M9 15.7375C8.41667 15.7375 7.91667 15.5292 7.5 15.1125C7.08333 14.6958 6.875 ' +
            '14.1958 6.875 13.6125C6.875 13.0292 7.08333 12.5292 7.5 12.1125C7.91667 ' +
            '11.6958 8.41667 11.4875 9 11.4875C9.58333 11.4875 10.0833 11.6958 10.5 12.1125C10.9167 ' +
            '12.5292 11.125 13.0292 11.125 13.6125C11.125 14.1958 10.9167 14.6958 10.5 ' +
            '15.1125C10.0833 15.5292 9.58333 15.7375 9 15.7375ZM5.625 21.1125C5.15833 ' +
            '21.1125 4.771 20.9585 4.463 20.6505C4.15433 20.3418 4 19.9542 4 19.4875V6.7375C4 ' +
            '6.27083 4.15433 5.8835 4.463 5.5755C4.771 5.26683 5.15833 5.1125 5.625 ' +
            '5.1125H7.375V2.8875H8.45V5.1125H15.625V2.8875H16.625V5.1125H18.375C18.8417 ' +
            '5.1125 19.2293 5.26683 19.538 5.5755C19.846 5.8835 20 6.27083 20 6.7375V19.4875C20 ' +
            '19.9542 19.846 20.3418 19.538 20.6505C19.2293 20.9585 18.8417 21.1125 18.375 ' +
            '21.1125H5.625ZM5.625 20.1125H18.375C18.5417 20.1125 18.6873 20.0498 18.812 ' +
            '19.9245C18.9373 19.7998 19 19.6542 19 19.4875V10.7375H5V19.4875C5 19.6542 5.06267 ' +
            '19.7998 5.188 19.9245C5.31267 20.0498 5.45833 20.1125 5.625 20.1125ZM5 ' +
            '9.7375H19V6.7375C19 6.57083 18.9373 6.42516 18.812 6.3005C18.6873 6.17516 ' +
            '18.5417 6.1125 18.375 6.1125H5.625C5.45833 6.1125 5.31267 6.17516 5.188 6.3005C5.06267 ' +
            '6.42516 5 6.57083 5 6.7375V9.7375Z' })));

const CalEndIcon = (props) => {
    return (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": 'calEndIcon' }),
        React.createElement("path", { d: 'M14.875 18.1125C14.2917 18.1125 13.7957 17.9042 13.387 17.4875C12.979 17.0708 ' +
                '12.775 16.5708 12.775 15.9875C12.775 15.4042 12.979 14.9082 13.387 14.4995C13.7957 ' +
                '14.0915 14.2917 13.8875 14.875 13.8875C15.4583 13.8875 15.9583 14.0915 16.375 ' +
                '14.4995C16.7917 14.9082 17 15.4042 17 15.9875C17 16.5708 16.7917 17.0708 16.375 ' +
                '17.4875C15.9583 17.9042 15.4583 18.1125 14.875 18.1125ZM5.625 21.1125C5.15833 ' +
                '21.1125 4.771 20.9585 4.463 20.6505C4.15433 20.3418 4 19.9542 4 19.4875V6.7375C4 ' +
                '6.27083 4.15433 5.8835 4.463 5.5755C4.771 5.26683 5.15833 5.1125 5.625 ' +
                '5.1125H7.375V2.8875H8.45V5.1125H15.625V2.8875H16.625V5.1125H18.375C18.8417 ' +
                '5.1125 19.2293 5.26683 19.538 5.5755C19.846 5.8835 20 6.27083 20 6.7375V19.4875C20 ' +
                '19.9542 19.846 20.3418 19.538 20.6505C19.2293 20.9585 18.8417 21.1125 18.375 ' +
                '21.1125H5.625ZM5.625 20.1125H18.375C18.5417 20.1125 18.6873 20.0498 18.812 ' +
                '19.9245C18.9373 19.7998 19 19.6542 19 19.4875V10.7375H5V19.4875C5 19.6542 5.06267 ' +
                '19.7998 5.188 19.9245C5.31267 20.0498 5.45833 20.1125 5.625 20.1125ZM5 ' +
                '9.7375H19V6.7375C19 6.57083 18.9373 6.42516 18.812 6.3005C18.6873 6.17516 ' +
                '18.5417 6.1125 18.375 6.1125H5.625C5.45833 6.1125 5.31267 6.17516 5.188 6.3005C5.06267 ' +
                '6.42516 5 6.57083 5 6.7375V9.7375Z' })));
};

const DividerInBetween = ({ children, sx, }) => {
    return (React.createElement(index.Stack, { direction: 'row', alignItems: 'self-end' },
        children[0],
        React.createElement(Divider, { sx: Object.assign({ position: 'relative', alignSelf: 'center', margin: 1, width: 16 }, sx) }),
        children[1]));
};

const determineTop = ({ themeName, hasLabel, hasHelperText, isRequired, }) => {
    if (themeName === 'Fortress') {
        if (hasLabel && (hasHelperText || isRequired)) {
            return 4;
        }
        else if (hasHelperText || isRequired) {
            return -8;
        }
        else if (hasLabel) {
            return 12;
        }
    }
    if (themeName === 'Portal') {
        if (hasLabel && (hasHelperText || isRequired)) {
            return 12;
        }
        else if (hasHelperText || isRequired) {
            return -10;
        }
        else if (hasLabel) {
            return 2;
        }
        return -8;
    }
    return 0;
};

const COLUMNS = {
    FROM: '70% 30%',
    TO: '30% 70%',
};
const DateRangePicker = ({ FromProps, ToProps, compact }) => {
    const [themeName] = index.useThemeName();
    const [gridTemplateColumns, setGridTemplateColumns] = React.useState(COLUMNS.FROM);
    const hasLabel = Boolean((FromProps === null || FromProps === void 0 ? void 0 : FromProps.label) || (ToProps === null || ToProps === void 0 ? void 0 : ToProps.label));
    const hasHelperText = Boolean((FromProps === null || FromProps === void 0 ? void 0 : FromProps.helperText) || (ToProps === null || ToProps === void 0 ? void 0 : ToProps.helperText));
    const isRequired = Boolean((FromProps === null || FromProps === void 0 ? void 0 : FromProps.required) || (ToProps === null || ToProps === void 0 ? void 0 : ToProps.required));
    if (compact) {
        return (React.createElement(index.Box, { display: 'inline-grid', gridTemplateColumns: gridTemplateColumns, sx: {
                transition: ({ transitions: { create, duration, easing } }) => create('grid-template-columns', {
                    duration: duration.shortest,
                    easing: easing.easeOut,
                }),
            } },
            React.createElement(DatePicker.default, Object.assign({ placeholder: 'From' }, FromProps, { compact: true, helperText: null, CalendarIcon: CalStartIcon, InputProps: Object.assign(Object.assign({}, FromProps === null || FromProps === void 0 ? void 0 : FromProps.InputProps), { fullWidth: false, onMouseOver: () => setGridTemplateColumns(COLUMNS.FROM), sx: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                    } }) })),
            React.createElement(DatePicker.default, Object.assign({ placeholder: 'To' }, ToProps, { compact: true, helperText: null, CalendarIcon: CalEndIcon, InputProps: Object.assign(Object.assign({}, ToProps === null || ToProps === void 0 ? void 0 : ToProps.InputProps), { onMouseOver: () => setGridTemplateColumns(COLUMNS.TO), sx: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                    } }) }))));
    }
    return (React.createElement(DividerInBetween, { sx: {
            top: determineTop({ hasLabel, hasHelperText, isRequired, themeName }),
        } },
        React.createElement(DatePicker.default, Object.assign({ placeholder: 'From', CalendarIcon: CalStartIcon }, FromProps)),
        React.createElement(DatePicker.default, Object.assign({ placeholder: 'To', CalendarIcon: CalEndIcon }, ToProps))));
};
DateRangePicker.defaultProps = {
    FromProps: {},
    ToProps: {},
};
DateRangePicker.displayName = 'DateRangePicker';

exports.DateRangePicker = DateRangePicker;
exports.default = DateRangePicker;
